import { Record } from 'immutable';

export default class BeneficialOwnerRecord extends Record({
    id: null,
    first_name: '',
    last_name: '',
    dob: '',
    ssn: '',
    email: '',
    address: {
      address1: '',
      city: '',
      state: '',
      zip: ''
    }
  }) {
    get full_name() {
      return `${this.first_name || ''} ${this.last_name || ''}`.trim();
    }
  }
